document.addEventListener("click", function (e) {
    // Show Email Form
    if (e.target.closest(".show_email")) {
        e.preventDefault();

        const container = e.target.closest(".show_email").closest(".klaviyo-footer-container");

        container.querySelector(".email-klaviyo-footer-form")?.classList.add("active");
        container.querySelector(".phone-klaviyo-footer-form")?.classList.remove("active");
    }

    // Show Phone Form
    if (e.target.closest(".show_phone")) {
        e.preventDefault();

        const container = e.target.closest(".show_phone").closest(".klaviyo-footer-container");

        container.querySelector(".phone-klaviyo-footer-form")?.classList.add("active");
        container.querySelector(".email-klaviyo-footer-form")?.classList.remove("active");
    }
});

const footerInputs = document.querySelectorAll('.klaviyo-footer-form .klaviyo-footer-input');

footerInputs.forEach((footerInput) => {
  footerInput.addEventListener('input', () => {
    footerInput.classList.toggle('typing', footerInput.value.trim() !== '');
  });
});

function setFooterPlaceholders() {
  const inputs = document.querySelectorAll('.klaviyo-footer-form .klaviyo-footer-input');

  inputs.forEach((input) => {
    const desktopText = input.dataset.placeholderDesktop;
    const mobileText = input.dataset.placeholderMobile;

    if (!desktopText || !mobileText) return;

    input.placeholder = window.innerWidth < 990 ? mobileText : desktopText;
  });
}

setFooterPlaceholders();
window.addEventListener('resize', setFooterPlaceholders);